import range from 'lodash/range';
import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import ReactDatePicker from 'react-datepicker';
import styled from 'styled-components';
import { getMonth, getYear } from '../../../utils/helper';
import { StyledCustomButton } from '../styledComponents/StyledCustomButton';
import { CustomDropdownStyle } from '../styledComponents/StyledCustomDropdown';
import ArrowLeft from '../svgIcons/ArrowLeft';
import ArrowRight from '../svgIcons/ArrowRight';
import BottomArrowAlt from '../svgIcons/BottomArrowAlt';

const years = range(1990, getYear(new Date()) + 1, 1);
const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const CustomDropdownStyleButton = styled(CustomDropdownStyle)`
  button {
    width: 100px !important;
  }
`;

const StyledDatePicker = styled.div`
  .react-datepicker__header {
    border-bottom: none;
    background-color: ${({ theme }) => theme.white};
    button {
      border: none;
      background-color: white;
    }
    .react-datepicker__day-name {
      height: 44px;
      width: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 10px;
      line-height: 12px;
      border-radius: 10px;
      text-transform: uppercase;
      margin: 0;
    }
    .calender-month-dropdown {
      max-width: 150px;
      width: 100%;
      min-width: 0;
      max-height: 310px;
      overflow-y: auto;
    }
  }
  .react-datepicker {
    width: 100%;
    border: none;
    border-radius: 20px;
    overflow: hidden;
    .react-datepicker__month-container {
      float: inherit;
    }
    .react-datepicker__month {
      margin: 8px 24px 20px 24px;
    }
    .react-datepicker__day-names {
      display: flex;
      margin: 32px 24px 0 24px;
      border-bottom: 1px solid ${({ theme }) => theme.inputBorder};
    }
    .react-datepicker__week {
      display: flex;
      justify-content: space-around;
      .react-datepicker__day {
        margin: 0;
        height: 44px;
        width: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        line-height: 20px;
        border-radius: 10px;
        color: ${({ theme }) => theme.primaryDark};
        &.react-datepicker__day--in-range {
          background-color: ${({ theme }) => theme.primaryLight2};
          color: black;
          border-radius: 0px;

          &.react-datepicker__day--keyboard-selected {
            background-color: ${({ theme }) => theme.primary};
            color: ${({ theme }) => theme.white};
            border-radius: 0px 10px 10px 0px;
          }
        }
        &.react-datepicker__day--in-selecting-range {
          background-color: ${({ theme }) => theme.primaryLight2};
          color: black;
          border-radius: 0px;
        }
        &.react-datepicker__day--selected {
          background-color: ${({ theme }) => theme.primary};
          color: ${({ theme }) => theme.white};
          border-radius: 10px 0px 0px 10px;
        }
      }
    }
  }
`;
const CalenderFooter = styled.div`
  margin: 0 1rem;
  padding: 10px 0;
  border-top: 1px solid ${({ theme }) => theme.inputBorder};
  text-align: right;
  button {
    margin-left: 10px;
    border: 1px solid ${({ theme }) => theme.primary};
    line-height: 17px;
    font-size: 14px;
    padding: 10px 20px;
    height: fit-content;
    font-weight: 500;
  }
`;

export const CalenderHeader = styled.div`
  display: flex;
  margin: 32px 5px 0;
  gap: 10px;
  .table-dropdown.menu-toggle {
    height: 44px;
    width: 100%;

    button {
      width: 100% !important;
    }
  }
  div {
    &:nth-child(3) {
      max-width: 87px;
    }
  }
`;

const DatePicker = ({ selectedDate, selectedEndDate, onChange }) => {
  const [currentDate, setCurrentDate] = useState(selectedDate);
  const [endDate, setEndDate] = useState(selectedEndDate);

  const handleReset = () => {
    setCurrentDate(undefined);
    setEndDate(undefined);
  };
  const handleChange = (dates) => {
    const [start, end] = dates;
    setCurrentDate(start);
    setEndDate(end);
  };

  useEffect(() => {
    setCurrentDate(selectedDate);
    setEndDate(selectedEndDate);
  }, [selectedDate, selectedEndDate]);

  return (
    <StyledDatePicker>
      <ReactDatePicker
        formatWeekDay={(nameOfDay) => nameOfDay.slice(0, 3)}
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <CalenderHeader>
            <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
              <ArrowLeft />
            </button>
            <CustomDropdownStyleButton
              toggleClassName="table-dropdown ms-0 table-text"
              className="custom-drop-down custom-drop-down-width table-dropdown-custom topic-dropdown bg-white w-100"
              dropdownToggle={
                <span className="flex-center p-2 w-100 justify-content-between">
                  <h6 className="me-1 me-lg-2 mb-0 ">
                    {months[getMonth(date)]}
                  </h6>
                  <BottomArrowAlt height={24} />
                </span>
              }
              menuClassName="calender-month-dropdown"
              dropdownMenu={
                <>
                  {months.map((option) => (
                    <Dropdown.Item
                      key={option}
                      onClick={() => changeMonth(months.indexOf(option))}
                    >
                      <span>{option}</span>
                    </Dropdown.Item>
                  ))}
                </>
              }
            />
            <CustomDropdownStyleButton
              toggleClassName="table-dropdown ms-0 table-text"
              className="custom-drop-down custom-drop-down-width table-dropdown-custom topic-dropdown bg-white w-100"
              dropdownToggle={
                <span className="flex-center p-2 w-100 justify-content-between ">
                  <h6 className="me-1 me-lg-2 mb-0 ">{getYear(date)}</h6>
                  <BottomArrowAlt height={24} />
                </span>
              }
              menuClassName="calender-month-dropdown"
              align="end"
              dropdownMenu={
                <>
                  {years.map((option) => (
                    <Dropdown.Item
                      key={option}
                      onClick={() => changeYear(option)}
                    >
                      <span>{option}</span>
                    </Dropdown.Item>
                  ))}
                </>
              }
            />

            <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
              <ArrowRight />
            </button>
          </CalenderHeader>
        )}
        selected={currentDate}
        onChange={handleChange}
        startDate={currentDate}
        endDate={endDate}
        selectsRange
        inline
      />
      <CalenderFooter>
        <StyledCustomButton.BtnOutlineDefault onClick={handleReset}>
          Reset
        </StyledCustomButton.BtnOutlineDefault>
        <StyledCustomButton.BtnDefault
          onClick={() =>
            onChange({ currentDate: currentDate, endDate: endDate })
          }
          disabled={endDate === null || endDate === undefined}
        >
          Done
        </StyledCustomButton.BtnDefault>
      </CalenderFooter>
    </StyledDatePicker>
  );
};

export default DatePicker;
